// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import { connect } from 'react-redux';
// COMPONENTS
import PinsList from './Users/PinsList';
import { BounceMessage } from './Modals/BounceMessage';
import { Contact } from './Modals/Contact';
import { Footer } from "./Footer";
import { About } from "./Main/About";

// INNER IMPORTS
import { createDeleteMessage } from '../Models/strings';
import { LIVE_MUSIC, SERVICE } from '../consts';

// actions
import {
    userPinsCall,
    openLoginModal,
    editPin,
    bouncePin,
    removePin,
    openSubmitModalRequest,
    submitWaitingLogin,
    closeBounceModal,
    openParticipateModal,
    editBandFinderPin,
    toggleHeroAds,
    clearPinWaiting
} from '../Actions/users';
import {
    getDatatypes,
    openPayingMethodsModal,
    openGeneralMessageModal,
    closeContactModal,
    resetFiltersType,
    openContactModal
} from '../Actions/main';

// styles


class UserPanel extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

        this.props.userPinsCall(this.props.token);
        this.props.getDatatypes();

        if (!this.props.token) {
            browserHistory.replace('/');
            browserHistory.push('/#');
            this.props.openLoginModal();
            return;
        }

        // this is a hack for mobile back button - see more in Top Bar
        window.location.hash = '#b';
    }

    componentWillReceiveProps(nextProps) {
        if ((this.props.savingPin && !nextProps.savingPin) || (this.props.removingPin && !nextProps.removingPin)) {
            this.props.userPinsCall(this.props.token);
        }
    }

    editPin(pin) {
        if (pin.type === LIVE_MUSIC || pin.type === SERVICE) {
            this.props.editPin(pin);

            return;
        }

        this.props.editBandFinderPin(pin);
    }

    bouncePin(pin) {
        this.props.bouncePin(this.props.token, pin);
    }

    handleChangeType(cat) {
        this.props.resetFiltersType(cat);

        browserHistory.push('/')
    }

    removePin(pin) {
        // if(!window.confirm('Are you sure you want to delete ' + pin.name + ' ad?')) return;

        const { header, body } = createDeleteMessage(pin.name);

        this.props.openGeneralMessageModal(header, body, null, () => {
            this.props.removePin(this.props.token, pin._id);
        });
    }

    newPin(type) {
        if (type === SERVICE || type === LIVE_MUSIC) {
            this.props.openSubmitModalRequest(type);
            return;
        }

        this.props.openSubmitModalRequest((type));
    }

    selectEnrolHandler() {
        // for now there is no use in the enrol user selects from the drop down
        this.props.clearPinWaiting()
        // this.props.openPayingMethodsModal();
        browserHistory.push('/packages');
    }

    // https://blog.ramboll.com/fehmarnbelt/wp-content/themes/ramboll2/images/profile-img.jpg

    render() {
        if (!this.props.token) return null;

        return (
            <div className="UserPanel rtl">
                <BounceMessage
                    isModalOpen={this.props.isBounceModalOpen}
                    closeModal={() => this.props.closeBounceModal()}
                />
                {this.props.datatypes ? this.props.datatypes.types.map((type, index) => {
                    return (
                        <PinsList
                            isTempUser={this.props.isTempUser}
                            key={index}
                            type={type}
                            pins={this.props.myPins.filter((pin)=> pin.type === type.name).reverse()}
                            editPin={this.editPin.bind(this)}
                            bouncePin={this.bouncePin.bind((this))}
                            removePin={this.removePin.bind(this)}
                            newPin={this.newPin.bind(this)}
                            datatypes={this.props.datatypes}
                            selectEnroll={() => this.selectEnrolHandler()}
                            handleHeroAdToggle={ pinId => this.props.toggleHeroAds(pinId) }
                        />
                    )
                }):
                    null
                }

                <Contact
                    isModalOpen={this.props.isContactModalOpen}
                    closeModal={this.props.closeContactModal}
                />

                <About isHideJoin isHideContact onPress={this.props.openParticipateModal} openContact={this.props.openContactModal} />

                <Footer
                    isShowFooter
                    onPress={this.props.openParticipateModal}
                    openContact={this.props.openContactModal}
                    filterChange={value => this.handleChangeType(value)}
                    datatypes={this.props.datatypes}
                />

            </div>
        );
    }
}

const mapStateToProps = state => ({
    myPins: state.users.myPins || [],
    token: state.users.token,
    isTempUser: state.users.isTempUser,
    savingPin: state.users.savingPin,
    removingPin: state.users.removingPin,
    datatypes: state.main.datatypes,
    isBounceModalOpen: state.users.isBounceModalOpen,
    isContactModalOpen: state.main.isContactModalOpen
});

UserPanel.propTypes = {
    // actions
    openPayingMethodsModal: PropTypes.func,
    openGeneralMessageModal: PropTypes.func,
    getDatatypes: PropTypes.func,
    closeContactModal: PropTypes.func,
    isContactModalOpen: PropTypes.bool,
    openTempUserModal: PropTypes.func,
    resetFiltersType: PropTypes.func,
    openContactModal: PropTypes.func,

    userPinsCall: PropTypes.func,
    openLoginModal: PropTypes.func,
    editPin: PropTypes.func,
    editBandFinderPin: PropTypes.func,
    bouncePin: PropTypes.func,
    removePin: PropTypes.func,
    openSubmitModalRequest: PropTypes.func,
    submitWaitingLogin: PropTypes.func,
    closeBounceModal: PropTypes.func,
    openParticipateModal: PropTypes.func,
    toggleHeroAds: PropTypes.func,
    clearPinWaiting: PropTypes.func,

    // props from state
    datatypes: PropTypes.object,
    myPins: PropTypes.array,
    token: PropTypes.string,
    isBounceModalOpen: PropTypes.bool,
    isTempUser: PropTypes.bool,
    savingPin: PropTypes.bool,
    removingPin: PropTypes.bool
};

// connecting redux state to the component props
export const UserPanelContainer = connect(mapStateToProps, {
    getDatatypes,
    openPayingMethodsModal,
    openGeneralMessageModal,
    closeContactModal,
    resetFiltersType,
    openContactModal,

    userPinsCall,
    openLoginModal,
    editPin,
    editBandFinderPin,
    bouncePin,
    removePin,
    openSubmitModalRequest,
    submitWaitingLogin,
    closeBounceModal,
    openParticipateModal,
    toggleHeroAds,
    clearPinWaiting
})(UserPanel);

export default UserPanel;




// WEBPACK FOOTER //
// ./src/Components/UserPanel.js